export const categories = [
  {
    slug: "剧情",
    name: "剧情",
    icon: "ri-film-line",
    desc: "以人物与故事为核心的高质量叙事作品，注重情感与现实的刻画。",
  },
  {
    slug: "爱情",
    name: "爱情",
    icon: "ri-heart-3-line",
    desc: "聚焦都市与欧陆情感的浪漫佳作，探索关系中的温柔与矛盾。",
  },
  {
    slug: "动作",
    name: "动作",
    icon: "ri-sword-line",
    desc: "节奏紧凑、场面利落的类型片，兼具悬疑与视觉张力。",
  },
  {
    slug: "惊悚",
    name: "惊悚",
    icon: "ri-ghost-2-line",
    desc: "营造紧张氛围与心理悬念，情节反转令人欲罢不能。",
  },
  {
    slug: "合集专题",
    name: "合集专题",
    icon: "ri-stack-line",
    desc: "按主题精心挑选的影片合集，快速找到值得一看的佳片。",
  },
];